module.exports = __webpack_public_path__ + "img/down-long.772face9.svg";